var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "16",
        height: "17",
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { id: "Icons/icon/x" } }, [
        _c("path", {
          attrs: {
            id: "Vector",
            d: "M13.6153 4.163C14.1228 3.65543 14.1228 2.83113 13.6153 2.32355C13.1077 1.81598 12.2834 1.81598 11.7758 2.32355L7.5 6.60342L3.22013 2.32761C2.71256 1.82004 1.88826 1.82004 1.38068 2.32761C0.873106 2.83519 0.873106 3.65949 1.38068 4.16706L5.66055 8.44287L1.38474 12.7227C0.877167 13.2303 0.877167 14.0546 1.38474 14.5622C1.89232 15.0698 2.71662 15.0698 3.22419 14.5622L7.5 10.2823L11.7799 14.5581C12.2874 15.0657 13.1117 15.0657 13.6193 14.5581C14.1269 14.0506 14.1269 13.2263 13.6193 12.7187L9.33945 8.44287L13.6153 4.163Z",
            fill: "black",
            "fill-opacity": "0.88",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }